// Username
export const MAX_USERNAME_LENGTH = 70
export const MIN_USERNAME_LENGTH = 2

// Password
export const MAX_PW_LENGTH = 96
export const LEGACY_MIN_PW_LENGTH = 6
export const MIN_PW_LENGTH = 8
